<template>
  <!-- fake top bar for mobile when reel bar is open-->
  <div v-show="isMobile && isOpen" class="fixed top-0 left-0 w-screen h-16 bg-primary z-30"></div>

  <nav class="z-30 bg-primary p-4 flex flex-col md:items-center justify-between fixed transition-all duration-300 h-auto md:h-screen overflow-y-scroll no-scrollbar"
    :class="[
      isOpen ? 'animate-slide-in-nav' : isMobile ? 'animate-slide-out-nav-mobile' : 'animate-slide-out-nav',
      isMobile && isOpen ? 'h-screen' : '',
      isMobile && !isOpen ? 'w-screen' : ''
      ]">
    <div>
      <div class="flex flex-row justify-between items-center" :class="{'gap-12': !isConnected}" v-show="isOpen">
        <SimpleText content="Market I3D" color="text-white" size="text-xl" bolding="font-bold" />
        <button @click="toggleMenu" class="text-white hover:text-hover-white" :aria-label="t('closeNavMenu')">
          <font-awesome-icon icon="fas fa-times" class="text-3xl" />
        </button>
      </div>

      <font-awesome-icon icon="fas fa-bars" class="text-3xl text-white hover:text-hover-white" @click="toggleMenu" v-show="!isOpen"/>


      <div class="flex flex-col mt-8 gap-8" v-show="isOpen">
        <NavigationSection :titre="t('tools')" :childrens="[
          { text: t('createAnOrder'), redirect: '/commandes/create', show: () => isConnected },
          { text: t('myOrders'), redirect: '/commandes', show: () => isClient },
          { text: t('orders'), redirect: '/admin/commandes', show: () => isAdmin },
          { text: t('show3D'), redirect: '/model', show: () => isConnected },
          { text: t('versionsOnly'), redirect: '/versions', show: () => isConnected },
          { text: t('myAccount'), redirect: '/me', show: () => isConnected },
          { text: t('contact'), redirect: '/contact', show: () => true }
          ]" @click="closeAutomaticaly">
          <WhiteHammerIcon/>
        </NavigationSection>

        <NavigationSection v-if="isAdmin" :titre="t('administration')" :childrens="[
          { text: t('coils'), redirect: '/admin/bobines', show: () => isAdmin },
          { text: t('informations'), redirect: '/admin/informations', show: () => isAdmin },
          { text: t('colors'), redirect: '/admin/couleurs', show: () => isAdmin },
          { text: t('printers'), redirect: '/admin/imprimantes', show: () => isAdmin },
          { text: t('brands'), redirect: '/admin/marques', show: () => isAdmin },
          { text: t('filamentsType'), redirect: '/admin/typefilaments', show: () => isAdmin },
          { text: t('messages'), redirect: '/admin/contact', show: () => isAdmin },
          { text: t('users'), redirect: '/admin/utilisateurs', show: () => isAdmin },
          { text: t('register'), redirect: '/admin/inscription', show: () => isAdmin },
          ]" @click="closeAutomaticaly">
          <WhiteToolboxIcon/>
        </NavigationSection>
      </div>
    </div>

    <div class="flex flex-row items-center gap-2" v-show="isOpen">
      <WhitePowerOffIcon @click="() => {isConnected ? logout() : $router.push('/')}" class="cursor-pointer hover:text-hover-white" />
      <WhiteClickableText :text="t('logout')" v-if="isConnected" @click="logout" class="hover:text-hover-white" />
      <WhiteNavRouterLink v-else :text="t('login')" to="/" />
    </div>
  </nav>
</template>


<script setup>

import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {NotificationStores} from "@/stores/NotificationStores";
import {router} from "@/routeur";
import {enumeration} from '../../../Enumeration';
import {computed, defineProps} from "vue";
import {t} from "@/utils/Traduction";
import WhiteNavRouterLink from "@/components/molecules/WhiteNavRouterLink.vue";
import WhiteClickableText from "@/components/molecules/WhiteClickableText.vue";
import {BrouillonStore} from "@/stores/BrouillonStore";
import WhitePowerOffIcon from "@/components/atoms/WhitePowerOffIcon.vue";
import NavigationSection from "@/components/molecules/NavigationSection.vue";
import WhiteHammerIcon from "@/components/atoms/WhiteHammerIcon.vue";
import WhiteToolboxIcon from "@/components/atoms/WhiteToolboxIcon.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";

const utilisateurStore = UtilisateurStores();
const notificationStore = NotificationStores();
const brouillonStore = BrouillonStore();

const isConnected = computed(() => utilisateurStore.isConnected);
const isAdmin = computed(() => utilisateurStore.role === enumeration.role.ADMIN);
const isClient = computed(() => utilisateurStore.role === enumeration.role.CLIENT);

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: true
  },
  toggleMenu: {
    type: Function,
    required: true
  },
  closeMenu: {
    type: Function,
    required: true
  }
});

const isMobile = computed(() => window.innerWidth < 768);

const logout = async () => {
  utilisateurStore.logout(false);
  brouillonStore.brouillons = [];
  brouillonStore.brouillonsSelected = 0;

  notificationStore.addNotification(
      t("youAreDisconnected"),
      "success");

  await router.push("/");
}

const closeAutomaticaly = () => {
  if (isMobile.value) {
    props.closeMenu()
  }
}

</script>

<style scoped>

</style>